<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-form @submit.prevent="saveItem">
          <b-row>
            <b-col cols="12" class="mb-3">
              <b-button variant="primary" @click="$router.go(-1)" class="pull-left">Terug</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-tabs>
                <b-tab title="Basisgegevens" active>
                  <b-row>
                    <b-col cols="12" md="12">
                      <b-row>
                        <b-col cols="12" md="6">
                          <b-form-group label="Sectie">
                            <b-form-radio-group
                              id="radio-group-1"
                              v-model="item.section"
                              :disabled="!editable"
                            >
                              <b-form-radio value="content">Landelijke content</b-form-radio>
                              <b-form-radio value="links">links</b-form-radio>
                            </b-form-radio-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12" md="6">
                          <b-form-group label="Naam">
                            <b-form-input type="text" required v-model="item.name" :disabled="!editable"></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row v-if="item.section === 'content'">
                        <b-col cols="12" md="6">
                          <b-form-group label="Thumbail">
                            <p v-if="current_featured_image"><img :alt="current_featured_image.name" :src="current_featured_image.url" class="img img-thumbnail" width="100"><br>
                              <a href="#" v-if="editable" @click.prevent="clearFeaturedImage">Verwijder afbeelding</a></p>
                            <b-form-file v-else v-model="featuredImageFile" :disabled="saveButtonDisabled || !editable" placeholder="Selecteer een bestand..."></b-form-file>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12" md="6">
                          <b-form-group label="Type">
                            <b-form-radio-group
                              id="radio-group-2"
                              v-model="item.type"
                              disabled
                            >
                              <b-form-radio value="file">bestand</b-form-radio>
                              <b-form-radio value="link">link</b-form-radio>
                            </b-form-radio-group>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row v-if="item.type === 'file'">
                        <b-col cols="12" md="6">
                          <b-form-group label="Bestand">
                              <p v-if="current_file">{{ current_file}}<br>
                                <a href="#" v-if="editable" @click.prevent="clearFile">Verwijder bestand</a></p>
                              <b-form-file v-else v-model="file" :disabled="saveButtonDisabled || !editable" placeholder="Selecteer een bestand..."></b-form-file>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row v-if="item.type == 'link'">
                        <b-col cols="12" md="6">
                          <b-form-group label="Link">
                            <b-form-input type="text" required v-model="item.link" :disabled="!editable"></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <hr>
                          <div v-if="editable">
                          <b-button @click.prevent="cancelEdit" class="mr-3" variant="warning">Annuleren</b-button>
                            <b-button type="submit" variant="success" class="pull-right" :disabled="saveButtonDisabled">Wijzigingen opslaan</b-button>
                          </div>
                          <div v-if="!editable">
                          <b-button type="button" @click.prevent="editable = true" variant="primary" class="pull-right">Bewerken</b-button>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { updateData, getData } from '../../api';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: 'chili-template',

  components: {
    ClassicEditor
  },

  data() {
    return {
      saveButtonDisabled: false,
      editable: false,
      item: {},
      featuredImageFile: null,
      file: null,
    };
  },

  methods: {
    async refresh() {
      await this.getItem();
    },

    async getItem() {
      this.item = await getData('downloads/' + this.$route.params.id).then(
        (response) => response.data.data
      );
    },

    async saveItem() {
      this.saveButtonDisabled = true;

      let formData = new FormData();
      Object.keys(this.item).forEach(key => {
        formData.append(key, this.item[key]);
      });

      const request = await updateData('downloads/' + this.$route.params.id, formData);

      if (request.status === 200) {
        this.editable = false;
        this.saveButtonDisabled = false;
        await this.getItem();
      } else {
        this.editable = true;
        this.saveButtonDisabled = false;
      }
    },
    cancelEdit() {
      this.editable = false;
      this.getItem();
    },
    clearFeaturedImage() {
      this.item.featured_image = '';
      this.item.new_featured_image = '';
    },
    clearFile() {
      this.item.file = '';
      this.item.new_file = '';
    },
  },

  computed: {
    userRole: function() {
      return this.$store.state.userRole;
    },
    current_featured_image () {
      return this.item && this.item.featured_image;
    },
    current_file () {
      return this.item && this.item.file;
    }
  },

  watch: {
    'featuredImageFile'(newValue) {
      this.item.new_featured_image = newValue;
    },
    'file'(newValue) {
      this.item.new_file = newValue;
    }
  },
  beforeMount() {
    this.getItem();
  },
};
</script>
